/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(15).EventEmitter;
	
	function Emitter() {
	    EventEmitter.call(this);
	    this.setMaxListeners(20);
	}
	
	Emitter.prototype = Object.create(EventEmitter.prototype);
	Emitter.prototype.constructor = Emitter;
	
	Emitter.prototype.off = function(type, listener) {
	    if (listener) {
	        return this.removeListener(type, listener);
	    }
	    if (type) {
	        return this.removeAllListeners(type);
	    }
	    return this.removeAllListeners();
	};
	
	module.exports = Emitter;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assetsLoader = __webpack_require__(7);
	assetsLoader.stats = __webpack_require__(3);
	
	module.exports = assetsLoader;


/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    mbs: 0,
	    secs: 0,
	    update: function(request, startTime, url, log) {
	        var length;
	        var headers = request.getAllResponseHeaders();
	        if (headers) {
	            var match = headers.match(/content-length: (\d+)/i);
	            if (match && match.length) {
	                length = match[1];
	            }
	        }
	        // var length = request.getResponseHeader('Content-Length');
	        if (length) {
	            length = parseInt(length, 10);
	            var mbs = length / 1024 / 1024;
	            var secs = (Date.now() - startTime) / 1000;
	            this.secs += secs;
	            this.mbs += mbs;
	            if (log) {
	                this.log(url, mbs, secs);
	            }
	        } else if(log) {
	            console.warn.call(console, 'Can\'t get Content-Length:', url);
	        }
	    },
	    log: function(url, mbs, secs) {
	        if (url) {
	            var file = 'File loaded: ' +
	                url.substr(url.lastIndexOf('/') + 1) +
	                ' size:' + mbs.toFixed(2) + 'mb' +
	                ' time:' + secs.toFixed(2) + 's' +
	                ' speed:' + (mbs / secs).toFixed(2) + 'mbps';
	
	            console.log.call(console, file);
	        }
	        var total = 'Total loaded: ' + this.mbs.toFixed(2) + 'mb' +
	            ' time:' + this.secs.toFixed(2) + 's' +
	            ' speed:' + this.getMbps().toFixed(2) + 'mbps';
	        console.log.call(console, total);
	    },
	    getMbps: function() {
	        return this.mbs / this.secs;
	    }
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FINAL_LOSE_TO_MENU_DURATION_WHEN_NO_WEIGHT = exports.FINAL_LOSE_TO_MENU_DURATION_WHEN_WAS_WEIGHT = exports.FINAL_WIN_TO_MENU_DURATION = exports.TIMER_DURATION = exports.SCENE_NAME_ACTION_KING_WIN = exports.SCENE_NAME_ACTION_HAMLET_WIN = exports.SCENE_NAME_LOOP = exports.SCENE_NAME_ITEM_SELECTION = exports.SCENE_NAME_MENU = exports.ITEM_WEIGHT_DELTA = exports.ITEM_PISTOL = exports.ITEM_SNAKE = exports.ITEM_LOSINI = exports.ITEM_YAD = exports.ITEM_VANTUZ = exports.ITEM_TUFLYA = exports.ITEM_BANAN = exports.ITEM_FEN = exports.KEY_CODE_SPACE = exports.KEY_CODE_ENTER = exports.KEY_CODE_Y = exports.KEY_CODE_V = exports.KEY_CODE_T = exports.KEY_CODE_B = exports.KEY_CODE_G = exports.KEY_CODE_F = exports.KEY_CODE_D = exports.KEY_CODE_S = exports.KEY_CODE_A = exports.KEY_CODE_W = exports.WEB_SOCKET_APP_PORT = exports.GAME_STATE_END = exports.GAME_STATE_PLAYING_SCENE = exports.GAME_STATE_SELECTION_SCENE = exports.GAME_STATE_START_SCENE = exports.GAME_STATE_INITIAL_LOADING = exports.VIDOE_MOBILE_PATH = exports.VIDOE_DESKTOP_PATH = exports.ASSETS_PATH = undefined;
	
	var _constants = __webpack_require__(20);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ASSETS_PATH = exports.ASSETS_PATH = 'assets';
	var VIDOE_DESKTOP_PATH = exports.VIDOE_DESKTOP_PATH = 'assets/video/desktop';
	var VIDOE_MOBILE_PATH = exports.VIDOE_MOBILE_PATH = 'assets/video/mobile';
	var GAME_STATE_INITIAL_LOADING = exports.GAME_STATE_INITIAL_LOADING = 10;
	var GAME_STATE_START_SCENE = exports.GAME_STATE_START_SCENE = 20;
	var GAME_STATE_SELECTION_SCENE = exports.GAME_STATE_SELECTION_SCENE = 30;
	var GAME_STATE_PLAYING_SCENE = exports.GAME_STATE_PLAYING_SCENE = 30;
	var GAME_STATE_END = exports.GAME_STATE_END = 30;
	
	var WEB_SOCKET_APP_PORT = exports.WEB_SOCKET_APP_PORT = constants.WEB_SOCKET_APP_PORT;
	
	var KEY_CODE_W = exports.KEY_CODE_W = 119;
	var KEY_CODE_A = exports.KEY_CODE_A = 97;
	var KEY_CODE_S = exports.KEY_CODE_S = 115;
	var KEY_CODE_D = exports.KEY_CODE_D = 100;
	var KEY_CODE_F = exports.KEY_CODE_F = 102;
	var KEY_CODE_G = exports.KEY_CODE_G = 103;
	var KEY_CODE_B = exports.KEY_CODE_B = 98;
	var KEY_CODE_T = exports.KEY_CODE_T = 116;
	var KEY_CODE_V = exports.KEY_CODE_V = 118;
	var KEY_CODE_Y = exports.KEY_CODE_Y = 121;
	var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
	var KEY_CODE_SPACE = exports.KEY_CODE_SPACE = 32;
	
	var ITEM_FEN = exports.ITEM_FEN = constants.ITEM_FEN;
	var ITEM_BANAN = exports.ITEM_BANAN = constants.ITEM_BANAN;
	var ITEM_TUFLYA = exports.ITEM_TUFLYA = constants.ITEM_TUFLYA;
	var ITEM_VANTUZ = exports.ITEM_VANTUZ = constants.ITEM_VANTUZ;
	var ITEM_YAD = exports.ITEM_YAD = constants.ITEM_YAD;
	
	var ITEM_LOSINI = exports.ITEM_LOSINI = 'los';
	var ITEM_SNAKE = exports.ITEM_SNAKE = 'snk';
	var ITEM_PISTOL = exports.ITEM_PISTOL = 'pis';
	
	var ITEM_WEIGHT_DELTA = exports.ITEM_WEIGHT_DELTA = constants.ITEM_WEIGHT_DELTA;
	
	var SCENE_NAME_MENU = exports.SCENE_NAME_MENU = 'menu';
	var SCENE_NAME_ITEM_SELECTION = exports.SCENE_NAME_ITEM_SELECTION = 'itemSelection';
	var SCENE_NAME_LOOP = exports.SCENE_NAME_LOOP = 'loop';
	var SCENE_NAME_ACTION_HAMLET_WIN = exports.SCENE_NAME_ACTION_HAMLET_WIN = 'hamletWin';
	var SCENE_NAME_ACTION_KING_WIN = exports.SCENE_NAME_ACTION_KING_WIN = 'kingWin';
	
	var TIMER_DURATION = exports.TIMER_DURATION = 30 * 1000;
	var FINAL_WIN_TO_MENU_DURATION = exports.FINAL_WIN_TO_MENU_DURATION = 5000;
	var FINAL_LOSE_TO_MENU_DURATION_WHEN_WAS_WEIGHT = exports.FINAL_LOSE_TO_MENU_DURATION_WHEN_WAS_WEIGHT = 3000;
	var FINAL_LOSE_TO_MENU_DURATION_WHEN_NO_WEIGHT = exports.FINAL_LOSE_TO_MENU_DURATION_WHEN_NO_WEIGHT = 6000;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Bean - copyright (c) Jacob Thornton 2011-2012
	  * https://github.com/fat/bean
	  * MIT license
	  */
	(function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else context[name] = definition()
	})('bean', this, function (name, context) {
	  name    = name    || 'bean'
	  context = context || this
	
	  var win            = window
	    , old            = context[name]
	    , namespaceRegex = /[^\.]*(?=\..*)\.|.*/
	    , nameRegex      = /\..*/
	    , addEvent       = 'addEventListener'
	    , removeEvent    = 'removeEventListener'
	    , doc            = document || {}
	    , root           = doc.documentElement || {}
	    , W3C_MODEL      = root[addEvent]
	    , eventSupport   = W3C_MODEL ? addEvent : 'attachEvent'
	    , ONE            = {} // singleton for quick matching making add() do one()
	
	    , slice          = Array.prototype.slice
	    , str2arr        = function (s, d) { return s.split(d || ' ') }
	    , isString       = function (o) { return typeof o == 'string' }
	    , isFunction     = function (o) { return typeof o == 'function' }
	
	      // events that we consider to be 'native', anything not in this list will
	      // be treated as a custom event
	    , standardNativeEvents =
	        'click dblclick mouseup mousedown contextmenu '                  + // mouse buttons
	        'mousewheel mousemultiwheel DOMMouseScroll '                     + // mouse wheel
	        'mouseover mouseout mousemove selectstart selectend '            + // mouse movement
	        'keydown keypress keyup '                                        + // keyboard
	        'orientationchange '                                             + // mobile
	        'focus blur change reset select submit '                         + // form elements
	        'load unload beforeunload resize move DOMContentLoaded '         + // window
	        'readystatechange message '                                      + // window
	        'error abort scroll '                                              // misc
	      // element.fireEvent('onXYZ'... is not forgiving if we try to fire an event
	      // that doesn't actually exist, so make sure we only do these on newer browsers
	    , w3cNativeEvents =
	        'show '                                                          + // mouse buttons
	        'input invalid '                                                 + // form elements
	        'touchstart touchmove touchend touchcancel '                     + // touch
	        'gesturestart gesturechange gestureend '                         + // gesture
	        'textinput '                                                     + // TextEvent
	        'readystatechange pageshow pagehide popstate '                   + // window
	        'hashchange offline online '                                     + // window
	        'afterprint beforeprint '                                        + // printing
	        'dragstart dragenter dragover dragleave drag drop dragend '      + // dnd
	        'loadstart progress suspend emptied stalled loadmetadata '       + // media
	        'loadeddata canplay canplaythrough playing waiting seeking '     + // media
	        'seeked ended durationchange timeupdate play pause ratechange '  + // media
	        'volumechange cuechange '                                        + // media
	        'checking noupdate downloading cached updateready obsolete '       // appcache
	
	      // convert to a hash for quick lookups
	    , nativeEvents = (function (hash, events, i) {
	        for (i = 0; i < events.length; i++) events[i] && (hash[events[i]] = 1)
	        return hash
	      }({}, str2arr(standardNativeEvents + (W3C_MODEL ? w3cNativeEvents : ''))))
	
	      // custom events are events that we *fake*, they are not provided natively but
	      // we can use native events to generate them
	    , customEvents = (function () {
	        var isAncestor = 'compareDocumentPosition' in root
	              ? function (element, container) {
	                  return container.compareDocumentPosition && (container.compareDocumentPosition(element) & 16) === 16
	                }
	              : 'contains' in root
	                ? function (element, container) {
	                    container = container.nodeType === 9 || container === window ? root : container
	                    return container !== element && container.contains(element)
	                  }
	                : function (element, container) {
	                    while (element = element.parentNode) if (element === container) return 1
	                    return 0
	                  }
	          , check = function (event) {
	              var related = event.relatedTarget
	              return !related
	                ? related == null
	                : (related !== this && related.prefix !== 'xul' && !/document/.test(this.toString())
	                    && !isAncestor(related, this))
	            }
	
	        return {
	            mouseenter: { base: 'mouseover', condition: check }
	          , mouseleave: { base: 'mouseout', condition: check }
	          , mousewheel: { base: /Firefox/.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel' }
	        }
	      }())
	
	      // we provide a consistent Event object across browsers by taking the actual DOM
	      // event object and generating a new one from its properties.
	    , Event = (function () {
	            // a whitelist of properties (for different event types) tells us what to check for and copy
	        var commonProps  = str2arr('altKey attrChange attrName bubbles cancelable ctrlKey currentTarget ' +
	              'detail eventPhase getModifierState isTrusted metaKey relatedNode relatedTarget shiftKey '  +
	              'srcElement target timeStamp type view which propertyName')
	          , mouseProps   = commonProps.concat(str2arr('button buttons clientX clientY dataTransfer '      +
	              'fromElement offsetX offsetY pageX pageY screenX screenY toElement'))
	          , mouseWheelProps = mouseProps.concat(str2arr('wheelDelta wheelDeltaX wheelDeltaY wheelDeltaZ ' +
	              'axis')) // 'axis' is FF specific
	          , keyProps     = commonProps.concat(str2arr('char charCode key keyCode keyIdentifier '          +
	              'keyLocation location'))
	          , textProps    = commonProps.concat(str2arr('data'))
	          , touchProps   = commonProps.concat(str2arr('touches targetTouches changedTouches scale rotation'))
	          , messageProps = commonProps.concat(str2arr('data origin source'))
	          , stateProps   = commonProps.concat(str2arr('state'))
	          , overOutRegex = /over|out/
	            // some event types need special handling and some need special properties, do that all here
	          , typeFixers   = [
	                { // key events
	                    reg: /key/i
	                  , fix: function (event, newEvent) {
	                      newEvent.keyCode = event.keyCode || event.which
	                      return keyProps
	                    }
	                }
	              , { // mouse events
	                    reg: /click|mouse(?!(.*wheel|scroll))|menu|drag|drop/i
	                  , fix: function (event, newEvent, type) {
	                      newEvent.rightClick = event.which === 3 || event.button === 2
	                      newEvent.pos = { x: 0, y: 0 }
	                      if (event.pageX || event.pageY) {
	                        newEvent.clientX = event.pageX
	                        newEvent.clientY = event.pageY
	                      } else if (event.clientX || event.clientY) {
	                        newEvent.clientX = event.clientX + doc.body.scrollLeft + root.scrollLeft
	                        newEvent.clientY = event.clientY + doc.body.scrollTop + root.scrollTop
	                      }
	                      if (overOutRegex.test(type)) {
	                        newEvent.relatedTarget = event.relatedTarget
	                          || event[(type == 'mouseover' ? 'from' : 'to') + 'Element']
	                      }
	                      return mouseProps
	                    }
	                }
	              , { // mouse wheel events
	                    reg: /mouse.*(wheel|scroll)/i
	                  , fix: function () { return mouseWheelProps }
	                }
	              , { // TextEvent
	                    reg: /^text/i
	                  , fix: function () { return textProps }
	                }
	              , { // touch and gesture events
	                    reg: /^touch|^gesture/i
	                  , fix: function () { return touchProps }
	                }
	              , { // message events
	                    reg: /^message$/i
	                  , fix: function () { return messageProps }
	                }
	              , { // popstate events
	                    reg: /^popstate$/i
	                  , fix: function () { return stateProps }
	                }
	              , { // everything else
	                    reg: /.*/
	                  , fix: function () { return commonProps }
	                }
	            ]
	          , typeFixerMap = {} // used to map event types to fixer functions (above), a basic cache mechanism
	
	          , Event = function (event, element, isNative) {
	              if (!arguments.length) return
	              event = event || ((element.ownerDocument || element.document || element).parentWindow || win).event
	              this.originalEvent = event
	              this.isNative       = isNative
	              this.isBean         = true
	
	              if (!event) return
	
	              var type   = event.type
	                , target = event.target || event.srcElement
	                , i, l, p, props, fixer
	
	              this.target = target && target.nodeType === 3 ? target.parentNode : target
	
	              if (isNative) { // we only need basic augmentation on custom events, the rest expensive & pointless
	                fixer = typeFixerMap[type]
	                if (!fixer) { // haven't encountered this event type before, map a fixer function for it
	                  for (i = 0, l = typeFixers.length; i < l; i++) {
	                    if (typeFixers[i].reg.test(type)) { // guaranteed to match at least one, last is .*
	                      typeFixerMap[type] = fixer = typeFixers[i].fix
	                      break
	                    }
	                  }
	                }
	
	                props = fixer(event, this, type)
	                for (i = props.length; i--;) {
	                  if (!((p = props[i]) in this) && p in event) this[p] = event[p]
	                }
	              }
	            }
	
	        // preventDefault() and stopPropagation() are a consistent interface to those functions
	        // on the DOM, stop() is an alias for both of them together
	        Event.prototype.preventDefault = function () {
	          if (this.originalEvent.preventDefault) this.originalEvent.preventDefault()
	          else this.originalEvent.returnValue = false
	        }
	        Event.prototype.stopPropagation = function () {
	          if (this.originalEvent.stopPropagation) this.originalEvent.stopPropagation()
	          else this.originalEvent.cancelBubble = true
	        }
	        Event.prototype.stop = function () {
	          this.preventDefault()
	          this.stopPropagation()
	          this.stopped = true
	        }
	        // stopImmediatePropagation() has to be handled internally because we manage the event list for
	        // each element
	        // note that originalElement may be a Bean#Event object in some situations
	        Event.prototype.stopImmediatePropagation = function () {
	          if (this.originalEvent.stopImmediatePropagation) this.originalEvent.stopImmediatePropagation()
	          this.isImmediatePropagationStopped = function () { return true }
	        }
	        Event.prototype.isImmediatePropagationStopped = function () {
	          return this.originalEvent.isImmediatePropagationStopped && this.originalEvent.isImmediatePropagationStopped()
	        }
	        Event.prototype.clone = function (currentTarget) {
	          //TODO: this is ripe for optimisation, new events are *expensive*
	          // improving this will speed up delegated events
	          var ne = new Event(this, this.element, this.isNative)
	          ne.currentTarget = currentTarget
	          return ne
	        }
	
	        return Event
	      }())
	
	      // if we're in old IE we can't do onpropertychange on doc or win so we use doc.documentElement for both
	    , targetElement = function (element, isNative) {
	        return !W3C_MODEL && !isNative && (element === doc || element === win) ? root : element
	      }
	
	      /**
	        * Bean maintains an internal registry for event listeners. We don't touch elements, objects
	        * or functions to identify them, instead we store everything in the registry.
	        * Each event listener has a RegEntry object, we have one 'registry' for the whole instance.
	        */
	    , RegEntry = (function () {
	        // each handler is wrapped so we can handle delegation and custom events
	        var wrappedHandler = function (element, fn, condition, args) {
	            var call = function (event, eargs) {
	                  return fn.apply(element, args ? slice.call(eargs, event ? 0 : 1).concat(args) : eargs)
	                }
	              , findTarget = function (event, eventElement) {
	                  return fn.__beanDel ? fn.__beanDel.ft(event.target, element) : eventElement
	                }
	              , handler = condition
	                  ? function (event) {
	                      var target = findTarget(event, this) // deleated event
	                      if (condition.apply(target, arguments)) {
	                        if (event) event.currentTarget = target
	                        return call(event, arguments)
	                      }
	                    }
	                  : function (event) {
	                      if (fn.__beanDel) event = event.clone(findTarget(event)) // delegated event, fix the fix
	                      return call(event, arguments)
	                    }
	            handler.__beanDel = fn.__beanDel
	            return handler
	          }
	
	        , RegEntry = function (element, type, handler, original, namespaces, args, root) {
	            var customType     = customEvents[type]
	              , isNative
	
	            if (type == 'unload') {
	              // self clean-up
	              handler = once(removeListener, element, type, handler, original)
	            }
	
	            if (customType) {
	              if (customType.condition) {
	                handler = wrappedHandler(element, handler, customType.condition, args)
	              }
	              type = customType.base || type
	            }
	
	            this.isNative      = isNative = nativeEvents[type] && !!element[eventSupport]
	            this.customType    = !W3C_MODEL && !isNative && type
	            this.element       = element
	            this.type          = type
	            this.original      = original
	            this.namespaces    = namespaces
	            this.eventType     = W3C_MODEL || isNative ? type : 'propertychange'
	            this.target        = targetElement(element, isNative)
	            this[eventSupport] = !!this.target[eventSupport]
	            this.root          = root
	            this.handler       = wrappedHandler(element, handler, null, args)
	          }
	
	        // given a list of namespaces, is our entry in any of them?
	        RegEntry.prototype.inNamespaces = function (checkNamespaces) {
	          var i, j, c = 0
	          if (!checkNamespaces) return true
	          if (!this.namespaces) return false
	          for (i = checkNamespaces.length; i--;) {
	            for (j = this.namespaces.length; j--;) {
	              if (checkNamespaces[i] == this.namespaces[j]) c++
	            }
	          }
	          return checkNamespaces.length === c
	        }
	
	        // match by element, original fn (opt), handler fn (opt)
	        RegEntry.prototype.matches = function (checkElement, checkOriginal, checkHandler) {
	          return this.element === checkElement &&
	            (!checkOriginal || this.original === checkOriginal) &&
	            (!checkHandler || this.handler === checkHandler)
	        }
	
	        return RegEntry
	      }())
	
	    , registry = (function () {
	        // our map stores arrays by event type, just because it's better than storing
	        // everything in a single array.
	        // uses '$' as a prefix for the keys for safety and 'r' as a special prefix for
	        // rootListeners so we can look them up fast
	        var map = {}
	
	          // generic functional search of our registry for matching listeners,
	          // `fn` returns false to break out of the loop
	          , forAll = function (element, type, original, handler, root, fn) {
	              var pfx = root ? 'r' : '$'
	              if (!type || type == '*') {
	                // search the whole registry
	                for (var t in map) {
	                  if (t.charAt(0) == pfx) {
	                    forAll(element, t.substr(1), original, handler, root, fn)
	                  }
	                }
	              } else {
	                var i = 0, l, list = map[pfx + type], all = element == '*'
	                if (!list) return
	                for (l = list.length; i < l; i++) {
	                  if ((all || list[i].matches(element, original, handler)) && !fn(list[i], list, i, type)) return
	                }
	              }
	            }
	
	          , has = function (element, type, original, root) {
	              // we're not using forAll here simply because it's a bit slower and this
	              // needs to be fast
	              var i, list = map[(root ? 'r' : '$') + type]
	              if (list) {
	                for (i = list.length; i--;) {
	                  if (!list[i].root && list[i].matches(element, original, null)) return true
	                }
	              }
	              return false
	            }
	
	          , get = function (element, type, original, root) {
	              var entries = []
	              forAll(element, type, original, null, root, function (entry) {
	                return entries.push(entry)
	              })
	              return entries
	            }
	
	          , put = function (entry) {
	              var has = !entry.root && !this.has(entry.element, entry.type, null, false)
	                , key = (entry.root ? 'r' : '$') + entry.type
	              ;(map[key] || (map[key] = [])).push(entry)
	              return has
	            }
	
	          , del = function (entry) {
	              forAll(entry.element, entry.type, null, entry.handler, entry.root, function (entry, list, i) {
	                list.splice(i, 1)
	                entry.removed = true
	                if (list.length === 0) delete map[(entry.root ? 'r' : '$') + entry.type]
	                return false
	              })
	            }
	
	            // dump all entries, used for onunload
	          , entries = function () {
	              var t, entries = []
	              for (t in map) {
	                if (t.charAt(0) == '$') entries = entries.concat(map[t])
	              }
	              return entries
	            }
	
	        return { has: has, get: get, put: put, del: del, entries: entries }
	      }())
	
	      // we need a selector engine for delegated events, use querySelectorAll if it exists
	      // but for older browsers we need Qwery, Sizzle or similar
	    , selectorEngine
	    , setSelectorEngine = function (e) {
	        if (!arguments.length) {
	          selectorEngine = doc.querySelectorAll
	            ? function (s, r) {
	                return r.querySelectorAll(s)
	              }
	            : function () {
	                throw new Error('Bean: No selector engine installed') // eeek
	              }
	        } else {
	          selectorEngine = e
	        }
	      }
	
	      // we attach this listener to each DOM event that we need to listen to, only once
	      // per event type per DOM element
	    , rootListener = function (event, type) {
	        if (!W3C_MODEL && type && event && event.propertyName != '_on' + type) return
	
	        var listeners = registry.get(this, type || event.type, null, false)
	          , l = listeners.length
	          , i = 0
	
	        event = new Event(event, this, true)
	        if (type) event.type = type
	
	        // iterate through all handlers registered for this type, calling them unless they have
	        // been removed by a previous handler or stopImmediatePropagation() has been called
	        for (; i < l && !event.isImmediatePropagationStopped(); i++) {
	          if (!listeners[i].removed) listeners[i].handler.call(this, event)
	        }
	      }
	
	      // add and remove listeners to DOM elements
	    , listener = W3C_MODEL
	        ? function (element, type, add) {
	            // new browsers
	            element[add ? addEvent : removeEvent](type, rootListener, false)
	          }
	        : function (element, type, add, custom) {
	            // IE8 and below, use attachEvent/detachEvent and we have to piggy-back propertychange events
	            // to simulate event bubbling etc.
	            var entry
	            if (add) {
	              registry.put(entry = new RegEntry(
	                  element
	                , custom || type
	                , function (event) { // handler
	                    rootListener.call(element, event, custom)
	                  }
	                , rootListener
	                , null
	                , null
	                , true // is root
	              ))
	              if (custom && element['_on' + custom] == null) element['_on' + custom] = 0
	              entry.target.attachEvent('on' + entry.eventType, entry.handler)
	            } else {
	              entry = registry.get(element, custom || type, rootListener, true)[0]
	              if (entry) {
	                entry.target.detachEvent('on' + entry.eventType, entry.handler)
	                registry.del(entry)
	              }
	            }
	          }
	
	    , once = function (rm, element, type, fn, originalFn) {
	        // wrap the handler in a handler that does a remove as well
	        return function () {
	          fn.apply(this, arguments)
	          rm(element, type, originalFn)
	        }
	      }
	
	    , removeListener = function (element, orgType, handler, namespaces) {
	        var type     = orgType && orgType.replace(nameRegex, '')
	          , handlers = registry.get(element, type, null, false)
	          , removed  = {}
	          , i, l
	
	        for (i = 0, l = handlers.length; i < l; i++) {
	          if ((!handler || handlers[i].original === handler) && handlers[i].inNamespaces(namespaces)) {
	            // TODO: this is problematic, we have a registry.get() and registry.del() that
	            // both do registry searches so we waste cycles doing this. Needs to be rolled into
	            // a single registry.forAll(fn) that removes while finding, but the catch is that
	            // we'll be splicing the arrays that we're iterating over. Needs extra tests to
	            // make sure we don't screw it up. @rvagg
	            registry.del(handlers[i])
	            if (!removed[handlers[i].eventType] && handlers[i][eventSupport])
	              removed[handlers[i].eventType] = { t: handlers[i].eventType, c: handlers[i].type }
	          }
	        }
	        // check each type/element for removed listeners and remove the rootListener where it's no longer needed
	        for (i in removed) {
	          if (!registry.has(element, removed[i].t, null, false)) {
	            // last listener of this type, remove the rootListener
	            listener(element, removed[i].t, false, removed[i].c)
	          }
	        }
	      }
	
	      // set up a delegate helper using the given selector, wrap the handler function
	    , delegate = function (selector, fn) {
	        //TODO: findTarget (therefore $) is called twice, once for match and once for
	        // setting e.currentTarget, fix this so it's only needed once
	        var findTarget = function (target, root) {
	              var i, array = isString(selector) ? selectorEngine(selector, root) : selector
	              for (; target && target !== root; target = target.parentNode) {
	                for (i = array.length; i--;) {
	                  if (array[i] === target) return target
	                }
	              }
	            }
	          , handler = function (e) {
	              var match = findTarget(e.target, this)
	              if (match) fn.apply(match, arguments)
	            }
	
	        // __beanDel isn't pleasant but it's a private function, not exposed outside of Bean
	        handler.__beanDel = {
	            ft       : findTarget // attach it here for customEvents to use too
	          , selector : selector
	        }
	        return handler
	      }
	
	    , fireListener = W3C_MODEL ? function (isNative, type, element) {
	        // modern browsers, do a proper dispatchEvent()
	        var evt = doc.createEvent(isNative ? 'HTMLEvents' : 'UIEvents')
	        evt[isNative ? 'initEvent' : 'initUIEvent'](type, true, true, win, 1)
	        element.dispatchEvent(evt)
	      } : function (isNative, type, element) {
	        // old browser use onpropertychange, just increment a custom property to trigger the event
	        element = targetElement(element, isNative)
	        isNative ? element.fireEvent('on' + type, doc.createEventObject()) : element['_on' + type]++
	      }
	
	      /**
	        * Public API: off(), on(), add(), (remove()), one(), fire(), clone()
	        */
	
	      /**
	        * off(element[, eventType(s)[, handler ]])
	        */
	    , off = function (element, typeSpec, fn) {
	        var isTypeStr = isString(typeSpec)
	          , k, type, namespaces, i
	
	        if (isTypeStr && typeSpec.indexOf(' ') > 0) {
	          // off(el, 't1 t2 t3', fn) or off(el, 't1 t2 t3')
	          typeSpec = str2arr(typeSpec)
	          for (i = typeSpec.length; i--;)
	            off(element, typeSpec[i], fn)
	          return element
	        }
	
	        type = isTypeStr && typeSpec.replace(nameRegex, '')
	        if (type && customEvents[type]) type = customEvents[type].base
	
	        if (!typeSpec || isTypeStr) {
	          // off(el) or off(el, t1.ns) or off(el, .ns) or off(el, .ns1.ns2.ns3)
	          if (namespaces = isTypeStr && typeSpec.replace(namespaceRegex, '')) namespaces = str2arr(namespaces, '.')
	          removeListener(element, type, fn, namespaces)
	        } else if (isFunction(typeSpec)) {
	          // off(el, fn)
	          removeListener(element, null, typeSpec)
	        } else {
	          // off(el, { t1: fn1, t2, fn2 })
	          for (k in typeSpec) {
	            if (typeSpec.hasOwnProperty(k)) off(element, k, typeSpec[k])
	          }
	        }
	
	        return element
	      }
	
	      /**
	        * on(element, eventType(s)[, selector], handler[, args ])
	        */
	    , on = function(element, events, selector, fn) {
	        var originalFn, type, types, i, args, entry, first
	
	        //TODO: the undefined check means you can't pass an 'args' argument, fix this perhaps?
	        if (selector === undefined && typeof events == 'object') {
	          //TODO: this can't handle delegated events
	          for (type in events) {
	            if (events.hasOwnProperty(type)) {
	              on.call(this, element, type, events[type])
	            }
	          }
	          return
	        }
	
	        if (!isFunction(selector)) {
	          // delegated event
	          originalFn = fn
	          args       = slice.call(arguments, 4)
	          fn         = delegate(selector, originalFn, selectorEngine)
	        } else {
	          args       = slice.call(arguments, 3)
	          fn         = originalFn = selector
	        }
	
	        types = str2arr(events)
	
	        // special case for one(), wrap in a self-removing handler
	        if (this === ONE) {
	          fn = once(off, element, events, fn, originalFn)
	        }
	
	        for (i = types.length; i--;) {
	          // add new handler to the registry and check if it's the first for this element/type
	          first = registry.put(entry = new RegEntry(
	              element
	            , types[i].replace(nameRegex, '') // event type
	            , fn
	            , originalFn
	            , str2arr(types[i].replace(namespaceRegex, ''), '.') // namespaces
	            , args
	            , false // not root
	          ))
	          if (entry[eventSupport] && first) {
	            // first event of this type on this element, add root listener
	            listener(element, entry.eventType, true, entry.customType)
	          }
	        }
	
	        return element
	      }
	
	      /**
	        * add(element[, selector], eventType(s), handler[, args ])
	        *
	        * Deprecated: kept (for now) for backward-compatibility
	        */
	    , add = function (element, events, fn, delfn) {
	        return on.apply(
	            null
	          , !isString(fn)
	              ? slice.call(arguments)
	              : [ element, fn, events, delfn ].concat(arguments.length > 3 ? slice.call(arguments, 5) : [])
	        )
	      }
	
	      /**
	        * one(element, eventType(s)[, selector], handler[, args ])
	        */
	    , one = function () {
	        return on.apply(ONE, arguments)
	      }
	
	      /**
	        * fire(element, eventType(s)[, args ])
	        *
	        * The optional 'args' argument must be an array, if no 'args' argument is provided
	        * then we can use the browser's DOM event system, otherwise we trigger handlers manually
	        */
	    , fire = function (element, type, args) {
	        var types = str2arr(type)
	          , i, j, l, names, handlers
	
	        for (i = types.length; i--;) {
	          type = types[i].replace(nameRegex, '')
	          if (names = types[i].replace(namespaceRegex, '')) names = str2arr(names, '.')
	          if (!names && !args && element[eventSupport]) {
	            fireListener(nativeEvents[type], type, element)
	          } else {
	            // non-native event, either because of a namespace, arguments or a non DOM element
	            // iterate over all listeners and manually 'fire'
	            handlers = registry.get(element, type, null, false)
	            args = [false].concat(args)
	            for (j = 0, l = handlers.length; j < l; j++) {
	              if (handlers[j].inNamespaces(names)) {
	                handlers[j].handler.apply(element, args)
	              }
	            }
	          }
	        }
	        return element
	      }
	
	      /**
	        * clone(dstElement, srcElement[, eventType ])
	        *
	        * TODO: perhaps for consistency we should allow the same flexibility in type specifiers?
	        */
	    , clone = function (element, from, type) {
	        var handlers = registry.get(from, type, null, false)
	          , l = handlers.length
	          , i = 0
	          , args, beanDel
	
	        for (; i < l; i++) {
	          if (handlers[i].original) {
	            args = [ element, handlers[i].type ]
	            if (beanDel = handlers[i].handler.__beanDel) args.push(beanDel.selector)
	            args.push(handlers[i].original)
	            on.apply(null, args)
	          }
	        }
	        return element
	      }
	
	    , bean = {
	          'on'                : on
	        , 'add'               : add
	        , 'one'               : one
	        , 'off'               : off
	        , 'remove'            : off
	        , 'clone'             : clone
	        , 'fire'              : fire
	        , 'Event'             : Event
	        , 'setSelectorEngine' : setSelectorEngine
	        , 'noConflict'        : function () {
	            context[name] = old
	            return this
	          }
	      }
	
	  // for IE, clean up on unload to avoid leaks
	  if (win.attachEvent) {
	    var cleanup = function () {
	      var i, entries = registry.entries()
	      for (i in entries) {
	        if (entries[i].type && entries[i].type !== 'unload') off(entries[i].element, entries[i].type)
	      }
	      win.detachEvent('onunload', cleanup)
	      win.CollectGarbage && win.CollectGarbage()
	    }
	    win.attachEvent('onunload', cleanup)
	  }
	
	  // initialize selector engine to internal default (qSA or throw Error)
	  setSelectorEngine()
	
	  return bean
	});


/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = (function() {
	    try {
	        return !!new Blob();
	    } catch (e) {
	        return false;
	    }
	}());


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Emitter = __webpack_require__(1);
	var createLoader = __webpack_require__(8);
	var autoId = 0;
	
	module.exports = function createGroup(config) {
	    var group;
	    var map = {};
	    var assets = [];
	    var queue = [];
	    var numLoaded = 0;
	    var numTotal = 0;
	    var loaders = {};
	
	    var add = function(options) {
	        // console.debug('add', options);
	        if (Array.isArray(options)) {
	            options.forEach(add);
	            return group;
	        }
	        var isGroup = !!options.assets && Array.isArray(options.assets);
	        // console.debug('isGroup', isGroup);
	        var loader;
	        if (isGroup) {
	            loader = createGroup(configure(options, config));
	        } else {
	            loader = createLoader(configure(options, config));
	        }
	        loader.once('destroy', destroyHandler);
	        queue.push(loader);
	        loaders[loader.id] = loader;
	        return group;
	    };
	
	    var get = function(id) {
	        if (!arguments.length) {
	            return assets;
	        }
	        if (map[id]) {
	            return map[id];
	        }
	        return loaders[id];
	    };
	
	    var find = function(id) {
	        if (get(id)) {
	            return get(id);
	        }
	        var found = null;
	        Object.keys(loaders).some(function(key) {
	            found = loaders[key].find && loaders[key].find(id);
	            return !!found;
	        });
	        return found;
	    };
	
	    var getExtension = function(url) {
	        return url && url.split('?')[0].split('.').pop().toLowerCase();
	    };
	
	    var configure = function(options, defaults) {
	        if (typeof options === 'string') {
	            var url = options;
	            options = {
	                url: url
	            };
	        }
	
	        if (options.isTouchLocked === undefined) {
	            options.isTouchLocked = defaults.isTouchLocked;
	        }
	
	        if (options.blob === undefined) {
	            options.blob = defaults.blob;
	        }
	
	        if (options.basePath === undefined) {
	            options.basePath = defaults.basePath;
	        }
	
	        options.id = options.id || options.url || String(++autoId);
	        options.type = options.type || getExtension(options.url);
	        options.crossOrigin = options.crossOrigin || defaults.crossOrigin;
	        options.webAudioContext = options.webAudioContext || defaults.webAudioContext;
	        options.log = defaults.log;
	
	        return options;
	    };
	
	    var start = function() {
	        numTotal = queue.length;
	
	        queue.forEach(function(loader) {
	            loader
	                .on('progress', progressHandler)
	                .once('complete', completeHandler)
	                .once('error', errorHandler)
	                .start();
	        });
	
	        queue = [];
	
	        return group;
	    };
	
	    var progressHandler = function(progress) {
	        var loaded = numLoaded + progress;
	        group.emit('progress', loaded / numTotal);
	    };
	
	    var completeHandler = function(asset, id, type) {
	        if (Array.isArray(asset)) {
	            asset = { id: id, file: asset, type: type };
	        }
	        numLoaded++;
	        group.emit('progress', numLoaded / numTotal);
	        map[asset.id] = asset.file;
	        assets.push(asset);
	        group.emit('childcomplete', asset);
	        checkComplete();
	    };
	
	    var errorHandler = function(err) {
	        numTotal--;
	        if (group.listeners('error').length) {
	            group.emit('error', err);
	        } else {
	            console.error(err);
	        }
	        checkComplete();
	    };
	
	    var destroyHandler = function(id) {
	        loaders[id] = null;
	        delete loaders[id];
	
	        map[id] = null;
	        delete map[id];
	
	        assets.some(function(asset, i) {
	            if (asset.id === id) {
	                assets.splice(i, 1);
	                return true;
	            }
	        });
	    };
	
	    var checkComplete = function() {
	        if (numLoaded >= numTotal) {
	            group.emit('complete', assets, map, config.id, 'group');
	        }
	    };
	
	    var destroy = function() {
	        while (queue.length) {
	            queue.pop().destroy();
	        }
	        group.off('error');
	        group.off('progress');
	        group.off('complete');
	        assets = [];
	        map = {};
	        config.webAudioContext = null;
	        numTotal = 0;
	        numLoaded = 0;
	
	        Object.keys(loaders).forEach(function(key) {
	            loaders[key].destroy();
	        });
	        loaders = {};
	
	        group.emit('destroy', group.id);
	
	        return group;
	    };
	
	    // emits: progress, error, complete, destroy
	
	    group = Object.create(Emitter.prototype, {
	        _events: {
	            value: {}
	        },
	        id: {
	            get: function() {
	                return config.id;
	            }
	        },
	        add: {
	            value: add
	        },
	        start: {
	            value: start
	        },
	        get: {
	            value: get
	        },
	        find: {
	            value: find
	        },
	        getLoader: {
	            value: function(id) {
	                return loaders[id];
	            }
	        },
	        loaded: {
	            get: function() {
	                return numLoaded >= numTotal;
	            }
	        },
	        file: {
	            get: function() {
	                return assets;
	            }
	        },
	        destroy: {
	            value: destroy
	        }
	    });
	
	    config = configure(config || {}, {
	        basePath: '',
	        blob: false,
	        touchLocked: false,
	        crossOrigin: null,
	        webAudioContext: null,
	        log: false
	    });
	
	    if (Array.isArray(config.assets)) {
	        add(config.assets);
	    }
	
	    return Object.freeze(group);
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Emitter = __webpack_require__(1);
	var browserHasBlob = __webpack_require__(6);
	var stats = __webpack_require__(3);
	
	module.exports = function(options) {
	    var id = options.id;
	    var basePath = options.basePath || '';
	    var url = options.url;
	    var type = options.type;
	    var crossOrigin = options.crossOrigin;
	    var isTouchLocked = options.isTouchLocked;
	    var blob = options.blob && browserHasBlob;
	    var webAudioContext = options.webAudioContext;
	    var log = options.log;
	
	    var loader;
	    var loadHandler;
	    var request;
	    var startTime;
	    var timeout;
	    var file;
	
	    var start = function() {
	        startTime = Date.now();
	
	        switch (type) {
	            case 'json':
	                loadJSON();
	                break;
	            case 'jpg':
	            case 'png':
	            case 'gif':
	            case 'webp':
	                loadImage();
	                break;
	            case 'mp3':
	            case 'ogg':
	            case 'opus':
	            case 'wav':
	            case 'm4a':
	                loadAudio();
	                break;
	            case 'ogv':
	            case 'mp4':
	            case 'webm':
	            case 'hls':
	                loadVideo();
	                break;
	            case 'bin':
	            case 'binary':
	                loadXHR('arraybuffer');
	                break;
	            case 'txt':
	            case 'text':
	                loadXHR('text');
	                break;
	            default:
	                throw 'AssetsLoader ERROR: Unknown type for file with URL: ' + basePath + url + ' (' + type + ')';
	        }
	    };
	
	    var dispatchComplete = function(data) {
	        if (!data) {
	            return;
	        }
	        file = {id: id, file: data, type: type};
	        loader.emit('progress', 1);
	        loader.emit('complete', file, id, type);
	        removeListeners();
	    };
	
	    var loadXHR = function(responseType, customLoadHandler) {
	        loadHandler = customLoadHandler || completeHandler;
	
	        request = new XMLHttpRequest();
	        request.open('GET', basePath + url, true);
	        request.responseType = responseType;
	        request.addEventListener('progress', progressHandler);
	        request.addEventListener('load', loadHandler);
	        request.addEventListener('error', errorHandler);
	        request.send();
	    };
	
	    var progressHandler = function(event) {
	        if (event.lengthComputable) {
	            loader.emit('progress', event.loaded / event.total);
	        }
	    };
	
	    var completeHandler = function() {
	        if (success()) {
	            dispatchComplete(request.response);
	        }
	    };
	
	    var success = function() {
	        // console.log('success', url, request.status);
	        if (request && request.status < 400) {
	            stats.update(request, startTime, url, log);
	            return true;
	        }
	        errorHandler(request && request.statusText);
	        return false;
	    };
	
	    // json
	
	    var loadJSON = function() {
	        loadXHR('json', function() {
	            if (success()) {
	                var data = request.response;
	                if (typeof data === 'string') {
	                    data = JSON.parse(data);
	                }
	                dispatchComplete(data);
	            }
	        });
	    };
	
	    // image
	
	    var loadImage = function() {
	        if (blob) {
	            loadImageBlob();
	        } else {
	            loadImageElement();
	        }
	    };
	
	    var loadImageElement = function() {
	        request = new Image();
	        if (crossOrigin) {
	            request.crossOrigin = 'anonymous';
	        }
	        request.addEventListener('error', errorHandler, false);
	        request.addEventListener('load', elementLoadHandler, false);
	        request.src = basePath + url;
	    };
	
	    var elementLoadHandler = function(event) {
	        window.clearTimeout(timeout);
	        if (!event && (request.error || !request.readyState)) {
	            errorHandler();
	            return;
	        }
	        dispatchComplete(request);
	    };
	
	    var loadImageBlob = function() {
	        loadXHR('blob', function() {
	            if (success()) {
	                request = new Image();
	                request.addEventListener('error', errorHandler, false);
	                request.addEventListener('load', imageBlobHandler, false);
	                request.src = window.URL.createObjectURL(request.response);
	            }
	        });
	    };
	
	    var imageBlobHandler = function() {
	        window.URL.revokeObjectURL(request.src);
	        dispatchComplete(request);
	    };
	
	    // audio
	
	    var loadAudio = function() {
	        if (webAudioContext) {
	            loadAudioBuffer();
	        } else {
	            loadMediaElement('audio');
	        }
	    };
	
	    // video
	
	    var loadVideo = function() {
	        if (blob) {
	            loadXHR('blob');
	        } else {
	            loadMediaElement('video');
	        }
	    };
	
	    // audio buffer
	
	    var loadAudioBuffer = function() {
	        loadXHR('arraybuffer', function() {
	            if (success()) {
	                webAudioContext.decodeAudioData(
	                    request.response,
	                    function(buffer) {
	                        request = null;
	                        dispatchComplete(buffer);
	                    },
	                    function(e) {
	                        errorHandler(e);
	                    }
	                );
	            }
	        });
	    };
	
	    // media element
	
	    var loadMediaElement = function(tagName) {
	        request = document.createElement(tagName);
	
	        if (!isTouchLocked) {
	            // timeout because sometimes canplaythrough doesn't fire
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(elementLoadHandler, 2000);
	            request.addEventListener('canplaythrough', elementLoadHandler, false);
	        }
	
	        request.addEventListener('error', errorHandler, false);
	        request.preload = 'auto';
	        request.src = basePath + url;
	        request.load();
	
	        if (isTouchLocked) {
	            dispatchComplete(request);
	        }
	    };
	
	    // error
	
	    var errorHandler = function(err) {
	        // console.log('errorHandler', url, err);
	        window.clearTimeout(timeout);
	
	        var message = err;
	
	        if (request && request.tagName && request.error) {
	            var ERROR_STATE = ['', 'ABORTED', 'NETWORK', 'DECODE', 'SRC_NOT_SUPPORTED'];
	            message = 'MediaError: ' + ERROR_STATE[request.error.code] + ' ' + request.src;
	        } else if (request && request.statusText) {
	            message = request.statusText;
	        } else if (err && err.message) {
	            message = err.message;
	        } else if (err && err.type) {
	            message = err.type;
	        }
	
	        loader.emit('error', 'Error loading "' + basePath + url + '" ' + message);
	
	        destroy();
	    };
	
	    // clean up
	
	    var removeListeners = function() {
	        loader.off('error');
	        loader.off('progress');
	        loader.off('complete');
	
	        if (request) {
	            request.removeEventListener('progress', progressHandler);
	            request.removeEventListener('load', loadHandler);
	            request.removeEventListener('error', errorHandler);
	            request.removeEventListener('load', elementLoadHandler);
	            request.removeEventListener('canplaythrough', elementLoadHandler);
	            request.removeEventListener('load', imageBlobHandler);
	        }
	    };
	
	    var destroy = function() {
	        removeListeners();
	
	        if (request && request.abort && request.readyState < 4) {
	            request.abort();
	        }
	
	        request = null;
	        webAudioContext = null;
	        file = null;
	
	        window.clearTimeout(timeout);
	
	        loader.emit('destroy', id);
	    };
	
	    // emits: progress, error, complete
	
	    loader = Object.create(Emitter.prototype, {
	        _events: {
	            value: {}
	        },
	        id: {
	            value: options.id
	        },
	        start: {
	            value: start
	        },
	        loaded: {
	            get: function() {
	                return !!file;
	            }
	        },
	        file: {
	            get: function() {
	                return file;
	            }
	        },
	        destroy: {
	            value: destroy
	        }
	    });
	
	    return Object.freeze(loader);
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _screenfull = __webpack_require__(17);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _bean = __webpack_require__(5);
	
	var _bean2 = _interopRequireDefault(_bean);
	
	var _assetsLoader = __webpack_require__(2);
	
	var _assetsLoader2 = _interopRequireDefault(_assetsLoader);
	
	__webpack_require__(19);
	
	var _constants = __webpack_require__(4);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _video = __webpack_require__(12);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _texts = __webpack_require__(10);
	
	var _texts2 = _interopRequireDefault(_texts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var random = __webpack_require__(16)();
	
	var KING_ITEMS = random.shuffle([constants.ITEM_LOSINI, constants.ITEM_SNAKE, constants.ITEM_PISTOL]);
	
	var App = function () {
	  function App(_ref) {
	    var _this = this;
	
	    var rootEl = _ref.rootEl;
	
	    _classCallCheck(this, App);
	
	    this.dom = {};
	    this.ctx = null;
	    this.gameState = constants.GAME_STATE_INITIAL_LOADING;
	    this.wasGameStarted = false;
	    this.kingItem = null;
	    this.kingItemPickingIndex = 0;
	    this.hamletItem = null;
	    this.canSelectHamletItem = false;
	    this.timerDuration = 0;
	    this.timerStartTime = 0;
	    this.timerFinished = false;
	    this.playingVideo = null;
	    this.mainActionStarted = false;
	    this.loadedVideos = {};
	
	    this.onLoadMainAssetsError = function (error) {
	      console.error(error);
	    };
	
	    this.onStartSceneButtonClick = function (event) {
	      _this.startGame();
	    };
	
	    this.onEndScenePlayAgainButtonClick = function (event) {
	      _this.startGame();
	    };
	
	    this.onSelectionItemClick = function (event) {
	      event.preventDefault();
	      var el = event.currentTarget;
	      if (el.classList.contains('is-fen')) {
	        _this.selectHamletItem('fen');
	      } else if (el.classList.contains('is-ban')) {
	        _this.selectHamletItem('ban');
	      } else if (el.classList.contains('is-tuf')) {
	        _this.selectHamletItem('tuf');
	      } else if (el.classList.contains('is-van')) {
	        _this.selectHamletItem('van');
	      } else if (el.classList.contains('is-yad')) {
	        _this.selectHamletItem('yad');
	      }
	    };
	
	    this.onBodyKeypress = function (event) {
	      event.preventDefault();
	      if (event.keyCode === constants.KEY_CODE_ENTER) {
	        if (_screenfull2.default.enabled) {
	          _screenfull2.default.request();
	        }
	      }
	
	      var keyCode = event.keyCode;
	
	      [[constants.KEY_CODE_A, constants.ITEM_FEN], [constants.KEY_CODE_S, constants.ITEM_BANAN], [constants.KEY_CODE_D, constants.ITEM_TUFLYA], [constants.KEY_CODE_F, constants.ITEM_VANTUZ], [constants.KEY_CODE_G, constants.ITEM_YAD]].forEach(function (data) {
	        var _data = _slicedToArray(data, 2),
	            itemKeyCode = _data[0],
	            item = _data[1];
	
	        if (itemKeyCode == keyCode) {
	          _this.selectHamletItem(item.name);
	        }
	      });
	
	      if (keyCode === constants.KEY_CODE_SPACE) {
	        _this.startGame();
	      }
	    };
	
	    this.resizeAll = function () {
	      var canvasEl = _this.dom.canvasEl;
	
	
	      var windowWidth = window.innerWidth;
	      var windowHeight = window.innerHeight;
	
	      var videoWidth = 1280;
	      var videoHeight = 720;
	
	      var width = window.innerWidth;
	      var height = videoHeight / (videoWidth / width);
	
	      if (height > windowHeight) {
	        height = windowHeight;
	        width = height * videoWidth / videoHeight;
	      }
	
	      // Firefox currently has a bug where the canvasHeight can't be read from
	      // the video, so we will make assumptions if this happens.
	
	      if (isNaN(height)) {
	        height = width / (4 / 3);
	      }
	
	      [].forEach.call(document.querySelectorAll('video'), function (el) {
	        el.setAttribute('width', width);
	        el.setAttribute('height', height);
	      });
	    };
	
	    this.renderTimer = function () {
	      if (_this.timerFinished) {
	        return;
	      }
	      var timerEl = _this.dom.timerEl;
	
	      var currTime = Date.now();
	      var delta = currTime - _this.timerStartTime;
	      var elapsedSecs = Math.round((_this.timerDuration - delta) / 1000);
	      if (elapsedSecs < 0) {
	        elapsedSecs = 0;
	        _this.timerFinished = true;
	        _this.onTimerFinished();
	        _this.removeIsVisible(timerEl, 1000);
	        return;
	      }
	      if (elapsedSecs < 10) {
	        elapsedSecs = '0' + elapsedSecs;
	      }
	
	      timerEl.innerText = '00:' + elapsedSecs;
	      requestAnimationFrame(_this.renderTimer);
	    };
	
	    this.render = function () {
	      var playingVideo = _this.playingVideo;
	
	      [].forEach.call(document.querySelectorAll('video'), function (el) {
	        if (el !== playingVideo) {
	          el.style.display = 'none';
	        }
	      });
	
	      if (playingVideo) {
	        playingVideo.el.style.display = 'block';
	        _this.resizeAll();
	      }
	    };
	
	    this.cacheDomEls(rootEl);
	    this.preRun();
	  }
	
	  _createClass(App, [{
	    key: 'cacheDomEls',
	    value: function cacheDomEls(rootEl) {
	      var dom = this.dom;
	
	
	      dom.rootEl = rootEl;
	      dom.loaderEl = rootEl.querySelector('.App-loader');
	      dom.containerEl = rootEl.querySelector('.App-container');
	      dom.timerEl = rootEl.querySelector('.App-timer');
	
	      dom.startSceneEl = rootEl.querySelector('.App-startScene');
	      dom.startSceneLogoEl = dom.startSceneEl.querySelector('.App-logo');
	      dom.startSceneStartButtonEl = dom.startSceneEl.querySelector('.App-startButton');
	
	      dom.selectionSceneEl = rootEl.querySelector('.App-selectionScene');
	      dom.selectionItemsEl = rootEl.querySelector('.App-selectionItems');
	      dom.selectionItemElArr = dom.selectionItemsEl.querySelectorAll('.App-selectionItem');
	
	      dom.endSceneEl = rootEl.querySelector('.App-endScene');
	      dom.endSceneLogoEl = dom.endSceneEl.querySelector('.App-logo');
	      dom.endSceneTextEl = dom.endSceneEl.querySelector('.App-endText');
	      dom.endScenePlayAgainButton = dom.endSceneEl.querySelector('.App-playAgainButton');
	    }
	  }, {
	    key: 'loadMainAssets',
	    value: function loadMainAssets() {
	      return new Promise(function (resolve, reject) {
	        var loader = (0, _assetsLoader2.default)({
	          assets: [{ url: 'assets/i/start.jpg' }, { url: 'assets/i/final.jpg' }, { url: 'assets/i/item_ban.png' }, { url: 'assets/i/item_fen.png' }, { url: 'assets/i/item_tuf.png' }, { url: 'assets/i/item_van.png' }, { url: 'assets/i/item_yad.png' }, { url: 'assets/music/main_menu_song.mp3' }, { url: 'assets/music/final_song.mp3' }]
	        });
	
	        loader.on('error', function (error) {
	          return reject(error);
	        });
	        loader.on('complete', function () {
	          return resolve();
	        });
	
	        loader.start();
	      });
	    }
	  }, {
	    key: 'showContainer',
	    value: function showContainer() {
	      var _this2 = this;
	
	      return new Promise(function (resolve) {
	        var _dom = _this2.dom,
	            loaderEl = _dom.loaderEl,
	            containerEl = _dom.containerEl;
	
	        _this2.removeIsVisible(loaderEl).then(function () {
	          _this2.addIsVisible(containerEl).then(function () {
	            resolve();
	          });
	        });
	      });
	    }
	  }, {
	    key: 'addIsVisible',
	    value: function addIsVisible(el) {
	      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	
	      return new Promise(function (resolve) {
	        el.style.visibility = 'visible';
	        setTimeout(function () {
	          el.classList.remove('is-visible_no');
	          el.classList.add('is-visible_yes');
	          if (duration === 0) {
	            resolve();
	          } else {
	            setTimeout(function () {
	              resolve();
	            }, duration);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'removeIsVisible',
	    value: function removeIsVisible(el) {
	      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	
	      return new Promise(function (resolve) {
	        el.classList.remove('is-visible_yes');
	        el.classList.add('is-visible_no');
	        if (duration === 0) {
	          el.style.visibility = 'hidden';
	          resolve();
	        } else {
	          setTimeout(function () {
	            el.style.visibility = 'hidden';
	            resolve();
	          }, duration);
	        }
	      });
	    }
	  }, {
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var _this3 = this;
	
	      var body = document;
	      var _dom2 = this.dom,
	          startSceneStartButtonEl = _dom2.startSceneStartButtonEl,
	          endScenePlayAgainButton = _dom2.endScenePlayAgainButton,
	          selectionItemElArr = _dom2.selectionItemElArr;
	
	      _bean2.default.on(body, 'keypress', this.onBodyKeypress);
	      _bean2.default.on(window, 'resize', function () {
	        _this3.resizeAll();
	      });
	      _bean2.default.on(startSceneStartButtonEl, 'click', this.onStartSceneButtonClick);
	      _bean2.default.on(endScenePlayAgainButton, 'click', this.onEndScenePlayAgainButtonClick);
	      [].forEach.call(selectionItemElArr, function (el) {
	        _bean2.default.on(el, 'click', _this3.onSelectionItemClick);
	      });
	    }
	  }, {
	    key: 'preRun',
	    value: function preRun() {
	      var _this4 = this;
	
	      this.loadMainAssets().then(function () {
	        _this4.bindEvents();
	        _this4.resizeAll();
	        _this4.addIsVisible(_this4.dom.startSceneEl, 0).then(function () {
	          _this4.showContainer().then(function () {
	            _this4.run();
	          });
	        });
	      }).catch(this.onLoadMainAssetsError);
	    }
	  }, {
	    key: 'showStartScene',
	    value: function showStartScene() {
	      var _this5 = this;
	
	      var _dom3 = this.dom,
	          startSceneEl = _dom3.startSceneEl,
	          selectionSceneEl = _dom3.selectionSceneEl,
	          endSceneEl = _dom3.endSceneEl;
	
	
	      return this.removeIsVisible(endSceneEl).then(function () {
	        _this5.addIsVisible(startSceneEl);
	      });
	    }
	  }, {
	    key: 'showSelectionScene',
	    value: function showSelectionScene() {
	      var _this6 = this;
	
	      var _dom4 = this.dom,
	          startSceneEl = _dom4.startSceneEl,
	          selectionSceneEl = _dom4.selectionSceneEl,
	          endSceneEl = _dom4.endSceneEl;
	
	      return this.removeIsVisible(startSceneEl).then(function () {
	        _this6.addIsVisible(selectionSceneEl);
	      });
	    }
	  }, {
	    key: 'showEndScene',
	    value: function showEndScene() {
	      var _this7 = this;
	
	      var _dom5 = this.dom,
	          startSceneEl = _dom5.startSceneEl,
	          selectionSceneEl = _dom5.selectionSceneEl,
	          endSceneEl = _dom5.endSceneEl;
	
	      return this.removeIsVisible(selectionSceneEl).then(function () {
	        _this7.addIsVisible(endSceneEl);
	      });
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      this.render();
	    }
	  }, {
	    key: 'startGame',
	    value: function startGame() {
	      var _this8 = this;
	
	      if (this.wasGameStarted) {
	        return;
	      }
	      if (this.finalSceneAudio) {
	        this.finalSceneAudio.pause();
	      }
	      if (this.menuSceneAudio) {
	        this.menuSceneAudio.pause();
	      }
	      this.wasGameStarted = true;
	
	      var _dom6 = this.dom,
	          startSceneEl = _dom6.startSceneEl,
	          endSceneEl = _dom6.endSceneEl;
	
	
	      this.createKingItem();
	      this.playIntro().then(function () {
	        _this8.showSelectionScene().then(function () {
	          _this8.startTimer();
	          _this8.enableHamletItemSelection();
	        });
	      });
	
	      Promise.all([this.removeIsVisible(startSceneEl), this.removeIsVisible(endSceneEl)]).then(function () {});
	    }
	  }, {
	    key: 'enableHamletItemSelection',
	    value: function enableHamletItemSelection() {
	      this.canSelectHamletItem = true;
	    }
	  }, {
	    key: 'disableHamletItemSelection',
	    value: function disableHamletItemSelection() {
	      this.canSelectHamletItem = false;
	    }
	  }, {
	    key: 'createKingItem',
	    value: function createKingItem() {
	      var item = KING_ITEMS[this.kingItemPickingIndex % KING_ITEMS.length];
	      this.kingItemPickingIndex++;
	      this.kingItem = item;
	    }
	  }, {
	    key: 'selectHamletItem',
	    value: function selectHamletItem(hamletItem) {
	      if (!this.canSelectHamletItem || this.hamletItem) {
	        return;
	      }
	      this.hamletItem = hamletItem;
	      this.disableHamletItemSelection();
	      this.startAction();
	    }
	  }, {
	    key: 'playIntro',
	    value: function playIntro() {
	      var _this9 = this;
	
	      var introVideo = new _video2.default({ filePath: this.getVideoPath({ type: 'intro', kingItem: this.kingItem }) });
	      var loopVideo = new _video2.default({ filePath: this.getVideoPath({ type: 'loop', kingItem: this.kingItem }) });
	      var winVideo = new _video2.default({ filePath: this.getVideoPath({ type: 'win', kingItem: this.kingItem }) });
	
	      var allVideosLoaded = this.loadedVideos[introVideo.filePath] && this.loadedVideos[loopVideo.filePath] && this.loadedVideos[winVideo.filePath];
	      if (!allVideosLoaded) {
	        this.showLoader();
	      }
	      return new Promise(function (resolve, reject) {
	        Promise.all([introVideo.load(), loopVideo.load(), winVideo.load()]).then(function () {
	          _this9.resizeAll();
	          _this9.loadedVideos[introVideo.filePath] = introVideo;
	          _this9.loadedVideos[loopVideo.filePath] = loopVideo;
	          _this9.loadedVideos[winVideo.filePath] = winVideo;
	
	          var afterVideosLoaded = function afterVideosLoaded() {
	            introVideo.play().then(function () {
	              _this9.setPlayingVideo(loopVideo);
	              loopVideo.playWithLoop({
	                loopEndDuration: 90
	              });
	              resolve();
	            });
	            _this9.setPlayingVideo(introVideo);
	            _this9.addIsVisible(_this9.playingVideo.el).then(function () {});
	          };
	
	          if (allVideosLoaded) {
	            afterVideosLoaded();
	          } else {
	            _this9.hideLoader().then(function () {
	              afterVideosLoaded();
	            });
	          }
	        }).catch(_this9.onVideoLoadError);
	      });
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this10 = this;
	
	      this.timerDuration = constants.TIMER_DURATION;
	      this.timerStartTime = Date.now();
	      this.timerFinished = false;
	      this.addIsVisible(this.dom.timerEl).then(function () {
	        _this10.renderTimer();
	      });
	    }
	  }, {
	    key: 'onTimerFinished',
	    value: function onTimerFinished() {
	      if (!this.mainActionStarted) {
	        this.disableHamletItemSelection();
	        this.removeIsVisible(this.dom.selectionSceneEl);
	        this.playHamletWin();
	      }
	    }
	  }, {
	    key: 'showLoader',
	    value: function showLoader() {
	      var _this11 = this;
	
	      return new Promise(function (resolve) {
	        _this11.addIsVisible(_this11.dom.loaderEl).then(function () {
	          resolve();
	        });
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    }
	  }, {
	    key: 'hideLoader',
	    value: function hideLoader() {
	      var _this12 = this;
	
	      return new Promise(function (resolve) {
	        _this12.removeIsVisible(_this12.dom.loaderEl).then(function () {
	          resolve();
	        });
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    }
	  }, {
	    key: 'getVideoPath',
	    value: function getVideoPath(_ref2) {
	      var type = _ref2.type,
	          kingItem = _ref2.kingItem,
	          hamletItem = _ref2.hamletItem;
	
	      var root = window.innerWidth > 980 ? constants.VIDOE_DESKTOP_PATH : constants.VIDOE_MOBILE_PATH;
	      if (type === 'action') {
	        return root + '/action_' + kingItem + '_' + hamletItem + '.mp4';
	      } else {
	        return root + '/' + type + '_' + kingItem + '.mp4';
	      }
	    }
	  }, {
	    key: 'setPlayingVideo',
	    value: function setPlayingVideo(video) {
	      this.playingVideo = video;
	      this.render();
	    }
	  }, {
	    key: 'playHamletWin',
	    value: function playHamletWin() {
	      var _this13 = this;
	
	      var video = new _video2.default({ filePath: this.getVideoPath({ type: 'win', kingItem: this.kingItem }) });
	      video.load().then(function () {
	        _this13.playingVideo.pause();
	        _this13.setPlayingVideo(video);
	        video.play();
	        setTimeout(function () {
	          _this13.onPlayHamletWinFinish();
	        }, 7000);
	      });
	    }
	  }, {
	    key: 'startAction',
	    value: function startAction() {
	      var _this14 = this;
	
	      var filePath = this.getVideoPath({
	        type: 'action',
	        kingItem: this.kingItem,
	        hamletItem: this.hamletItem
	      });
	
	      this.timerFinished = true;
	      this.mainActionStarted = true;
	      this.removeIsVisible(this.dom.selectionSceneEl).then(function () {
	        var isVideoAlreadyLoaded = _this14.loadedVideos[filePath];
	
	        if (!isVideoAlreadyLoaded) {
	          _this14.showLoader();
	        }
	
	        var video = new _video2.default({ filePath: filePath });
	
	        video.load().then(function () {
	          _this14.loadedVideos[filePath] = true;
	          var afterVideoLoaded = function afterVideoLoaded() {
	            _this14.playingVideo.pause();
	            _this14.setPlayingVideo(video);
	            video.play().then(function () {
	              _this14.onHamletLoseFinish();
	            });
	          };
	
	          if (isVideoAlreadyLoaded) {
	            afterVideoLoaded();
	          } else {
	            _this14.hideLoader().then(function () {
	              afterVideoLoaded();
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'onPlayHamletWinFinish',
	    value: function onPlayHamletWinFinish() {
	      var _this15 = this;
	
	      var _dom7 = this.dom,
	          canvasEl = _dom7.canvasEl,
	          endSceneEl = _dom7.endSceneEl,
	          endSceneTextEl = _dom7.endSceneTextEl;
	
	
	      var finalText = this.generateFinalTextWin();
	      endSceneTextEl.innerText = finalText;
	
	      this.removeIsVisible(this.playingVideo.el).then(function () {
	        _this15.addIsVisible(endSceneEl);
	        _this15.resetToStartScene();
	      });
	    }
	  }, {
	    key: 'onHamletLoseFinish',
	    value: function onHamletLoseFinish() {
	      var _this16 = this;
	
	      var _dom8 = this.dom,
	          canvasEl = _dom8.canvasEl,
	          endSceneEl = _dom8.endSceneEl,
	          endSceneTextEl = _dom8.endSceneTextEl;
	
	      this.playFinalSceneAudio();
	
	      var finalText = this.generateFinalTextLose();
	      endSceneTextEl.innerText = finalText;
	
	      this.removeIsVisible(this.playingVideo.el).then(function () {
	        _this16.addIsVisible(endSceneEl);
	        _this16.resetToStartScene();
	      });
	    }
	  }, {
	    key: 'resetToStartScene',
	    value: function resetToStartScene() {
	      this.wasGameStarted = false;
	      this.hamletItem = null;
	      this.timerFinished = false;
	      this.mainActionStarted = false;
	    }
	  }, {
	    key: 'playMenuSceneAudio',
	    value: function playMenuSceneAudio() {
	      if (!this.menuSceneAudio) {
	        this.menuSceneAudio = new Audio('assets/music/main_menu_song.mp3');
	        this.menuSceneAudio.loop = true;
	      }
	      this.menuSceneAudio.play();
	    }
	  }, {
	    key: 'playFinalSceneAudio',
	    value: function playFinalSceneAudio() {
	      if (!this.finalSceneAudio) {
	        this.finalSceneAudio = new Audio('assets/music/final_song.mp3');
	        this.finalSceneAudio.loop = false;
	      }
	      this.finalSceneAudio.play();
	    }
	  }, {
	    key: 'generateFinalTextLose',
	    value: function generateFinalTextLose() {
	      var hamletItem = this.hamletItem;
	      var kingItem = this.kingItem;
	      var key = void 0;
	      if (hamletItem) {
	        key = kingItem + '_' + hamletItem;
	      } else {
	        key = kingItem;
	      }
	      return _texts2.default[key];
	    }
	  }, {
	    key: 'generateFinalTextWin',
	    value: function generateFinalTextWin() {
	      return _texts2.default[this.kingItem];
	    }
	  }]);
	
	  return App;
	}();
	
	window.App = App;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var texts = {
	  'los_fen': 'Движением частиц материи убитый, упал он наземь, материей прикрытый',
	  'los_ban': 'Стемнело вдруг в глазах, банан не смог помочь',
	  'los_tuf': 'Как трудно устоять на замшевой коже планеты',
	  'los_van': 'Весь воздух удален и нечем тут дышать',
	  'los_yad': 'Один глоток казался несмертельным',
	
	  'snk_fen': 'Ты всё продул и всё начнёшь сначала, не пожалев того, что приобрел',
	  'snk_ban': 'С бананом в бой вступив, змеёю нахлебавши',
	  'snk_tuf': 'Рука тверда, дух чёрен, крепок яд',
	  'snk_van': 'Всё очевидно: отравлен поцелуй',
	  'snk_yad': 'Мгновение победы, но смерть была быстрей',
	
	  'pis_fen': 'Задуть до смерти не успел, погубила дура',
	  'pis_ban': 'О, Боги, голод убивает нас!',
	  'pis_tuf': 'Обычай соблюдал, но оступился малость',
	  'pis_van': 'Присосал блаженно, но чихнул смертельно',
	  'pis_yad': 'Смерть принял из-за жалости своей',
	
	  'los': 'Йорик, жизнь моя скучна',
	  'snk': 'Йорик, жизнь моя скучна',
	  'pis': 'Йорик, жизнь моя скучна'
	};
	
	exports.default = texts;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isWeightInInterval = exports.off = exports.once = exports.on = exports.convertRange = undefined;
	
	var _bean = __webpack_require__(5);
	
	var _bean2 = _interopRequireDefault(_bean);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertRange = function convertRange(oldValue, oldMin, oldMax, newMin, newMax, isRoundByInterval) {
	  if (isRoundByInterval) {
	    oldValue = Math.max(oldValue, oldMin);
	    oldValue = Math.min(oldValue, oldMax);
	  }
	  var oldRange = oldMax - oldMin;
	  var newValue = void 0;
	  var newRange = void 0;
	  if (oldRange == 0) newValue = newMin;else {
	    newRange = newMax - newMin;
	    newValue = (oldValue - oldMin) * newRange / oldRange + newMin;
	  }
	  return newValue;
	};
	
	var on = function on(el, eventName, callback) {
	  _bean2.default.on(el, eventName, callback);
	};
	
	var once = function once(el, eventName, callback) {
	  _bean2.default.one(el, eventName, callback);
	};
	
	var off = function off(el, eventName, callback) {
	  _bean2.default.off(el, eventName, callback);
	};
	
	var isWeightInInterval = function isWeightInInterval(value, weight) {
	  if (value >= weight - _constants.ITEM_WEIGHT_DELTA && value <= weight + _constants.ITEM_WEIGHT_DELTA) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	exports.convertRange = convertRange;
	exports.on = on;
	exports.once = once;
	exports.off = off;
	exports.isWeightInInterval = isWeightInInterval;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _assetsLoader = __webpack_require__(2);
	
	var _assetsLoader2 = _interopRequireDefault(_assetsLoader);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isIOS = function isIOS() {
	
	  var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];
	
	  if (!!navigator.platform) {
	    while (iDevices.length) {
	      if (navigator.platform === iDevices.pop()) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	var blobs = {};
	
	var Video = function () {
	  function Video(_ref) {
	    var _this = this;
	
	    var filePath = _ref.filePath;
	
	    _classCallCheck(this, Video);
	
	    this.onPlayWithLoopEnded = function (event) {
	      if (!_this.paused) {
	        _this.playWithLoop();
	      }
	    };
	
	    this.filePath = filePath;
	    // this.el = this.createVideoEl();
	    this.paused = true;
	    this.loadPromise = null;
	  }
	
	  _createClass(Video, [{
	    key: 'createVideoEl',
	    value: function createVideoEl() {
	      var videoEl = document.createElement('video');
	      videoEl.setAttribute('playsinline', '');
	      videoEl.setAttribute('webkit-playsinline', ''); // Support inline videos for iOS webviews.
	      videoEl.controls = false;
	      if (isIOS()) {
	        videoEl.muted = true;
	      }
	      return videoEl;
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      var _this2 = this;
	
	      if (this.loadPromise) {
	        return this.loadPromise;
	      }
	      this.loadPromise = new Promise(function (resolve, reject) {
	        var el = _this2.el,
	            filePath = _this2.filePath;
	
	
	        if (blobs[filePath]) {
	          _this2.onLoadComplete();
	          resolve();
	          return;
	        }
	
	        var loader = (0, _assetsLoader2.default)({
	          assets: [{
	            id: 'video_' + filePath,
	            blob: true,
	            url: filePath
	          }]
	        }).on('error', function (error) {
	          console.error(error);
	          reject(error);
	        }).on('progress', function (progress) {}).on('complete', function (assets) {
	          blobs[filePath] = loader.get('video_' + filePath);
	          _this2.onLoadComplete();
	          resolve();
	        }).start();
	      });
	      return this.loadPromise;
	    }
	  }, {
	    key: 'onLoadComplete',
	    value: function onLoadComplete() {
	      var filePath = this.filePath;
	
	      var blob = blobs[filePath];
	      var el = this.createVideoEl();
	      el.src = window.URL.createObjectURL(blob);
	      el.style.display = 'none';
	      el.className = 'App-videoCanvas';
	      this.el = el;
	
	      document.body.querySelector('.App-container').appendChild(el);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var _this3 = this;
	
	      this.paused = false;
	      return new Promise(function (resolve, reject) {
	        (0, _utils.once)(_this3.el, 'ended', function () {
	          _this3.paused = true;
	          resolve();
	        });
	
	        _this3.el.play();
	      });
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.paused = true;
	      this.el.pause();
	      (0, _utils.off)(this.el, 'ended', this.onPlayWithLoopEnded);
	    }
	  }, {
	    key: 'playWithLoop',
	    value: function playWithLoop(data) {
	      var _this4 = this;
	
	      var _ref2 = data || {},
	          loopEndDuration = _ref2.loopEndDuration;
	
	      (0, _utils.once)(this.el, 'ended', this.onPlayWithLoopEnded);
	      if (loopEndDuration) {
	        var timeupdate = function timeupdate() {
	          var currTime = _this4.el.currentTime;
	          var fullTime = _this4.el.duration;
	          var currPercent = currTime * 100 / fullTime;
	          if (currPercent >= loopEndDuration) {
	            (0, _utils.off)(_this4.el, 'timeupdate', timeupdate);
	            (0, _utils.off)(_this4.el, 'ended', _this4.onPlayWithLoopEnded);
	            _this4.el.pause();
	            _this4.el.currentTime = 0;
	            setTimeout(function () {
	              if (!_this4.paused) {
	                _this4.playWithLoop(data);
	              }
	            });
	          }
	        };
	        (0, _utils.on)(this.el, 'timeupdate', timeupdate);
	      }
	      this.paused = false;
	      this.el.play();
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.el.currentTime;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.el.duration;
	    }
	  }, {
	    key: 'getEl',
	    value: function getEl() {
	      return this.el;
	    }
	  }]);
	
	  return Video;
	}();
	
	exports.default = Video;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, "body{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.App,.App-container{height:100%}.App-loader{z-index:999;position:absolute;left:50%;transform:translate(-50%)}.App .is-visible_yes{opacity:1;visibility:visible}.App .is-visible_no{opacity:0;visibility:hidden}.App-videoCanvas{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:10}.App .App-endScene,.App .App-selectionScene,.App .App-startScene{position:absolute;left:0;top:0;right:0;bottom:0;z-index:20;transition:opacity .5s}.App .App-startScene{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.App .App-startScene .App-logo{width:90%;max-width:640px;height:50%;background:url(\"assets/i/start.jpg\") no-repeat 50%;background-size:contain;margin:0 auto}.App .App-startScene .App-startButton{display:inline-block;text-align:center;font-size:30px;background-color:#4b4b4b;color:#fff;border:0;padding:10px 20px;border-radius:10px;max-width:150px;cursor:pointer;transition:opacity .25s;outline:none;position:relative;text-transform:uppercase;letter-spacing:3px}.App .App-startScene .App-startButton:active,.App .App-startScene .App-startButton:hover{opacity:.8}.App .App-startScene .App-startButton:active{top:1px}.App-timer{z-index:30;font-size:60px;text-align:center;color:#fff;top:50px}.App-selectionItems,.App-timer{position:absolute;left:0;right:0}.App-selectionItems{bottom:30px;z-index:40;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.App-selectionItem{width:200px;max-width:200px;height:200px;margin:0 20px;padding:20px;border-radius:4px;background:no-repeat 50%;background-size:contain;transition:transform .35s;cursor:pointer;transform:translate(0)}.App-selectionItem:active,.App-selectionItem:hover{transform:translateY(-25px)}.App-selectionItem:active{top:1px}.App-selectionItem.is-ban{background-image:url(\"assets/i/item_ban.png\")}.App-selectionItem.is-fen{background-image:url(\"assets/i/item_fen.png\")}.App-selectionItem.is-tuf{background-image:url(\"assets/i/item_tuf.png\")}.App-selectionItem.is-van{background-image:url(\"assets/i/item_van.png\")}.App-selectionItem.is-yad{background-image:url(\"assets/i/item_yad.png\")}.App-endScene{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.App-endScene .App-logo{width:100%;max-width:640px;height:130px;background:url(\"assets/i/final.jpg\") no-repeat 50%;background-size:contain;margin:0 auto 50px}.App-endScene .App-playAgainButton{display:inline-block;text-align:center;white-space:nowrap;font-size:34px;background-color:#4b4b4b;color:#fff;border:0;padding:10px 20px;border-radius:10px;cursor:pointer;transition:opacity .25s;outline:none;position:relative;text-transform:uppercase;letter-spacing:3px}.App-endScene .App-playAgainButton:active,.App-endScene .App-playAgainButton:hover{opacity:.8}.App-endScene .App-playAgainButton:active{top:1px}.App-endScene .App-endText{color:#fff;text-align:center;font-size:24px;font-style:italic;max-width:700px;margin-left:auto;margin-right:auto;margin-bottom:200px}", ""]);
	
	// exports


/***/ },
/* 14 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 15 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*jshint eqnull:true*/
	(function (root) {
	  "use strict";
	
	  var GLOBAL_KEY = "Random";
	
	  var imul = (typeof Math.imul !== "function" || Math.imul(0xffffffff, 5) !== -5 ?
	    function (a, b) {
	      var ah = (a >>> 16) & 0xffff;
	      var al = a & 0xffff;
	      var bh = (b >>> 16) & 0xffff;
	      var bl = b & 0xffff;
	      // the shift by 0 fixes the sign on the high part
	      // the final |0 converts the unsigned value into a signed value
	      return (al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0;
	    } :
	    Math.imul);
	
	  var stringRepeat = (typeof String.prototype.repeat === "function" && "x".repeat(3) === "xxx" ?
	    function (x, y) {
	      return x.repeat(y);
	    } : function (pattern, count) {
	      var result = "";
	      while (count > 0) {
	        if (count & 1) {
	          result += pattern;
	        }
	        count >>= 1;
	        pattern += pattern;
	      }
	      return result;
	    });
	
	  function Random(engine) {
	    if (!(this instanceof Random)) {
	      return new Random(engine);
	    }
	
	    if (engine == null) {
	      engine = Random.engines.nativeMath;
	    } else if (typeof engine !== "function") {
	      throw new TypeError("Expected engine to be a function, got " + typeof engine);
	    }
	    this.engine = engine;
	  }
	  var proto = Random.prototype;
	
	  Random.engines = {
	    nativeMath: function () {
	      return (Math.random() * 0x100000000) | 0;
	    },
	    mt19937: (function (Int32Array) {
	      // http://en.wikipedia.org/wiki/Mersenne_twister
	      function refreshData(data) {
	        var k = 0;
	        var tmp = 0;
	        for (;
	          (k | 0) < 227; k = (k + 1) | 0) {
	          tmp = (data[k] & 0x80000000) | (data[(k + 1) | 0] & 0x7fffffff);
	          data[k] = data[(k + 397) | 0] ^ (tmp >>> 1) ^ ((tmp & 0x1) ? 0x9908b0df : 0);
	        }
	
	        for (;
	          (k | 0) < 623; k = (k + 1) | 0) {
	          tmp = (data[k] & 0x80000000) | (data[(k + 1) | 0] & 0x7fffffff);
	          data[k] = data[(k - 227) | 0] ^ (tmp >>> 1) ^ ((tmp & 0x1) ? 0x9908b0df : 0);
	        }
	
	        tmp = (data[623] & 0x80000000) | (data[0] & 0x7fffffff);
	        data[623] = data[396] ^ (tmp >>> 1) ^ ((tmp & 0x1) ? 0x9908b0df : 0);
	      }
	
	      function temper(value) {
	        value ^= value >>> 11;
	        value ^= (value << 7) & 0x9d2c5680;
	        value ^= (value << 15) & 0xefc60000;
	        return value ^ (value >>> 18);
	      }
	
	      function seedWithArray(data, source) {
	        var i = 1;
	        var j = 0;
	        var sourceLength = source.length;
	        var k = Math.max(sourceLength, 624) | 0;
	        var previous = data[0] | 0;
	        for (;
	          (k | 0) > 0; --k) {
	          data[i] = previous = ((data[i] ^ imul((previous ^ (previous >>> 30)), 0x0019660d)) + (source[j] | 0) + (j | 0)) | 0;
	          i = (i + 1) | 0;
	          ++j;
	          if ((i | 0) > 623) {
	            data[0] = data[623];
	            i = 1;
	          }
	          if (j >= sourceLength) {
	            j = 0;
	          }
	        }
	        for (k = 623;
	          (k | 0) > 0; --k) {
	          data[i] = previous = ((data[i] ^ imul((previous ^ (previous >>> 30)), 0x5d588b65)) - i) | 0;
	          i = (i + 1) | 0;
	          if ((i | 0) > 623) {
	            data[0] = data[623];
	            i = 1;
	          }
	        }
	        data[0] = 0x80000000;
	      }
	
	      function mt19937() {
	        var data = new Int32Array(624);
	        var index = 0;
	        var uses = 0;
	
	        function next() {
	          if ((index | 0) >= 624) {
	            refreshData(data);
	            index = 0;
	          }
	
	          var value = data[index];
	          index = (index + 1) | 0;
	          uses += 1;
	          return temper(value) | 0;
	        }
	        next.getUseCount = function() {
	          return uses;
	        };
	        next.discard = function (count) {
	          uses += count;
	          if ((index | 0) >= 624) {
	            refreshData(data);
	            index = 0;
	          }
	          while ((count - index) > 624) {
	            count -= 624 - index;
	            refreshData(data);
	            index = 0;
	          }
	          index = (index + count) | 0;
	          return next;
	        };
	        next.seed = function (initial) {
	          var previous = 0;
	          data[0] = previous = initial | 0;
	
	          for (var i = 1; i < 624; i = (i + 1) | 0) {
	            data[i] = previous = (imul((previous ^ (previous >>> 30)), 0x6c078965) + i) | 0;
	          }
	          index = 624;
	          uses = 0;
	          return next;
	        };
	        next.seedWithArray = function (source) {
	          next.seed(0x012bd6aa);
	          seedWithArray(data, source);
	          return next;
	        };
	        next.autoSeed = function () {
	          return next.seedWithArray(Random.generateEntropyArray());
	        };
	        return next;
	      }
	
	      return mt19937;
	    }(typeof Int32Array === "function" ? Int32Array : Array)),
	    browserCrypto: (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function" && typeof Int32Array === "function") ? (function () {
	      var data = null;
	      var index = 128;
	
	      return function () {
	        if (index >= 128) {
	          if (data === null) {
	            data = new Int32Array(128);
	          }
	          crypto.getRandomValues(data);
	          index = 0;
	        }
	
	        return data[index++] | 0;
	      };
	    }()) : null
	  };
	
	  Random.generateEntropyArray = function () {
	    var array = [];
	    var engine = Random.engines.nativeMath;
	    for (var i = 0; i < 16; ++i) {
	      array[i] = engine() | 0;
	    }
	    array.push(new Date().getTime() | 0);
	    return array;
	  };
	
	  function returnValue(value) {
	    return function () {
	      return value;
	    };
	  }
	
	  // [-0x80000000, 0x7fffffff]
	  Random.int32 = function (engine) {
	    return engine() | 0;
	  };
	  proto.int32 = function () {
	    return Random.int32(this.engine);
	  };
	
	  // [0, 0xffffffff]
	  Random.uint32 = function (engine) {
	    return engine() >>> 0;
	  };
	  proto.uint32 = function () {
	    return Random.uint32(this.engine);
	  };
	
	  // [0, 0x1fffffffffffff]
	  Random.uint53 = function (engine) {
	    var high = engine() & 0x1fffff;
	    var low = engine() >>> 0;
	    return (high * 0x100000000) + low;
	  };
	  proto.uint53 = function () {
	    return Random.uint53(this.engine);
	  };
	
	  // [0, 0x20000000000000]
	  Random.uint53Full = function (engine) {
	    while (true) {
	      var high = engine() | 0;
	      if (high & 0x200000) {
	        if ((high & 0x3fffff) === 0x200000 && (engine() | 0) === 0) {
	          return 0x20000000000000;
	        }
	      } else {
	        var low = engine() >>> 0;
	        return ((high & 0x1fffff) * 0x100000000) + low;
	      }
	    }
	  };
	  proto.uint53Full = function () {
	    return Random.uint53Full(this.engine);
	  };
	
	  // [-0x20000000000000, 0x1fffffffffffff]
	  Random.int53 = function (engine) {
	    var high = engine() | 0;
	    var low = engine() >>> 0;
	    return ((high & 0x1fffff) * 0x100000000) + low + (high & 0x200000 ? -0x20000000000000 : 0);
	  };
	  proto.int53 = function () {
	    return Random.int53(this.engine);
	  };
	
	  // [-0x20000000000000, 0x20000000000000]
	  Random.int53Full = function (engine) {
	    while (true) {
	      var high = engine() | 0;
	      if (high & 0x400000) {
	        if ((high & 0x7fffff) === 0x400000 && (engine() | 0) === 0) {
	          return 0x20000000000000;
	        }
	      } else {
	        var low = engine() >>> 0;
	        return ((high & 0x1fffff) * 0x100000000) + low + (high & 0x200000 ? -0x20000000000000 : 0);
	      }
	    }
	  };
	  proto.int53Full = function () {
	    return Random.int53Full(this.engine);
	  };
	
	  function add(generate, addend) {
	    if (addend === 0) {
	      return generate;
	    } else {
	      return function (engine) {
	        return generate(engine) + addend;
	      };
	    }
	  }
	
	  Random.integer = (function () {
	    function isPowerOfTwoMinusOne(value) {
	      return ((value + 1) & value) === 0;
	    }
	
	    function bitmask(masking) {
	      return function (engine) {
	        return engine() & masking;
	      };
	    }
	
	    function downscaleToLoopCheckedRange(range) {
	      var extendedRange = range + 1;
	      var maximum = extendedRange * Math.floor(0x100000000 / extendedRange);
	      return function (engine) {
	        var value = 0;
	        do {
	          value = engine() >>> 0;
	        } while (value >= maximum);
	        return value % extendedRange;
	      };
	    }
	
	    function downscaleToRange(range) {
	      if (isPowerOfTwoMinusOne(range)) {
	        return bitmask(range);
	      } else {
	        return downscaleToLoopCheckedRange(range);
	      }
	    }
	
	    function isEvenlyDivisibleByMaxInt32(value) {
	      return (value | 0) === 0;
	    }
	
	    function upscaleWithHighMasking(masking) {
	      return function (engine) {
	        var high = engine() & masking;
	        var low = engine() >>> 0;
	        return (high * 0x100000000) + low;
	      };
	    }
	
	    function upscaleToLoopCheckedRange(extendedRange) {
	      var maximum = extendedRange * Math.floor(0x20000000000000 / extendedRange);
	      return function (engine) {
	        var ret = 0;
	        do {
	          var high = engine() & 0x1fffff;
	          var low = engine() >>> 0;
	          ret = (high * 0x100000000) + low;
	        } while (ret >= maximum);
	        return ret % extendedRange;
	      };
	    }
	
	    function upscaleWithinU53(range) {
	      var extendedRange = range + 1;
	      if (isEvenlyDivisibleByMaxInt32(extendedRange)) {
	        var highRange = ((extendedRange / 0x100000000) | 0) - 1;
	        if (isPowerOfTwoMinusOne(highRange)) {
	          return upscaleWithHighMasking(highRange);
	        }
	      }
	      return upscaleToLoopCheckedRange(extendedRange);
	    }
	
	    function upscaleWithinI53AndLoopCheck(min, max) {
	      return function (engine) {
	        var ret = 0;
	        do {
	          var high = engine() | 0;
	          var low = engine() >>> 0;
	          ret = ((high & 0x1fffff) * 0x100000000) + low + (high & 0x200000 ? -0x20000000000000 : 0);
	        } while (ret < min || ret > max);
	        return ret;
	      };
	    }
	
	    return function (min, max) {
	      min = Math.floor(min);
	      max = Math.floor(max);
	      if (min < -0x20000000000000 || !isFinite(min)) {
	        throw new RangeError("Expected min to be at least " + (-0x20000000000000));
	      } else if (max > 0x20000000000000 || !isFinite(max)) {
	        throw new RangeError("Expected max to be at most " + 0x20000000000000);
	      }
	
	      var range = max - min;
	      if (range <= 0 || !isFinite(range)) {
	        return returnValue(min);
	      } else if (range === 0xffffffff) {
	        if (min === 0) {
	          return Random.uint32;
	        } else {
	          return add(Random.int32, min + 0x80000000);
	        }
	      } else if (range < 0xffffffff) {
	        return add(downscaleToRange(range), min);
	      } else if (range === 0x1fffffffffffff) {
	        return add(Random.uint53, min);
	      } else if (range < 0x1fffffffffffff) {
	        return add(upscaleWithinU53(range), min);
	      } else if (max - 1 - min === 0x1fffffffffffff) {
	        return add(Random.uint53Full, min);
	      } else if (min === -0x20000000000000 && max === 0x20000000000000) {
	        return Random.int53Full;
	      } else if (min === -0x20000000000000 && max === 0x1fffffffffffff) {
	        return Random.int53;
	      } else if (min === -0x1fffffffffffff && max === 0x20000000000000) {
	        return add(Random.int53, 1);
	      } else if (max === 0x20000000000000) {
	        return add(upscaleWithinI53AndLoopCheck(min - 1, max - 1), 1);
	      } else {
	        return upscaleWithinI53AndLoopCheck(min, max);
	      }
	    };
	  }());
	  proto.integer = function (min, max) {
	    return Random.integer(min, max)(this.engine);
	  };
	
	  // [0, 1] (floating point)
	  Random.realZeroToOneInclusive = function (engine) {
	    return Random.uint53Full(engine) / 0x20000000000000;
	  };
	  proto.realZeroToOneInclusive = function () {
	    return Random.realZeroToOneInclusive(this.engine);
	  };
	
	  // [0, 1) (floating point)
	  Random.realZeroToOneExclusive = function (engine) {
	    return Random.uint53(engine) / 0x20000000000000;
	  };
	  proto.realZeroToOneExclusive = function () {
	    return Random.realZeroToOneExclusive(this.engine);
	  };
	
	  Random.real = (function () {
	    function multiply(generate, multiplier) {
	      if (multiplier === 1) {
	        return generate;
	      } else if (multiplier === 0) {
	        return function () {
	          return 0;
	        };
	      } else {
	        return function (engine) {
	          return generate(engine) * multiplier;
	        };
	      }
	    }
	
	    return function (left, right, inclusive) {
	      if (!isFinite(left)) {
	        throw new RangeError("Expected left to be a finite number");
	      } else if (!isFinite(right)) {
	        throw new RangeError("Expected right to be a finite number");
	      }
	      return add(
	        multiply(
	          inclusive ? Random.realZeroToOneInclusive : Random.realZeroToOneExclusive,
	          right - left),
	        left);
	    };
	  }());
	  proto.real = function (min, max, inclusive) {
	    return Random.real(min, max, inclusive)(this.engine);
	  };
	
	  Random.bool = (function () {
	    function isLeastBitTrue(engine) {
	      return (engine() & 1) === 1;
	    }
	
	    function lessThan(generate, value) {
	      return function (engine) {
	        return generate(engine) < value;
	      };
	    }
	
	    function probability(percentage) {
	      if (percentage <= 0) {
	        return returnValue(false);
	      } else if (percentage >= 1) {
	        return returnValue(true);
	      } else {
	        var scaled = percentage * 0x100000000;
	        if (scaled % 1 === 0) {
	          return lessThan(Random.int32, (scaled - 0x80000000) | 0);
	        } else {
	          return lessThan(Random.uint53, Math.round(percentage * 0x20000000000000));
	        }
	      }
	    }
	
	    return function (numerator, denominator) {
	      if (denominator == null) {
	        if (numerator == null) {
	          return isLeastBitTrue;
	        }
	        return probability(numerator);
	      } else {
	        if (numerator <= 0) {
	          return returnValue(false);
	        } else if (numerator >= denominator) {
	          return returnValue(true);
	        }
	        return lessThan(Random.integer(0, denominator - 1), numerator);
	      }
	    };
	  }());
	  proto.bool = function (numerator, denominator) {
	    return Random.bool(numerator, denominator)(this.engine);
	  };
	
	  function toInteger(value) {
	    var number = +value;
	    if (number < 0) {
	      return Math.ceil(number);
	    } else {
	      return Math.floor(number);
	    }
	  }
	
	  function convertSliceArgument(value, length) {
	    if (value < 0) {
	      return Math.max(value + length, 0);
	    } else {
	      return Math.min(value, length);
	    }
	  }
	  Random.pick = function (engine, array, begin, end) {
	    var length = array.length;
	    var start = begin == null ? 0 : convertSliceArgument(toInteger(begin), length);
	    var finish = end === void 0 ? length : convertSliceArgument(toInteger(end), length);
	    if (start >= finish) {
	      return void 0;
	    }
	    var distribution = Random.integer(start, finish - 1);
	    return array[distribution(engine)];
	  };
	  proto.pick = function (array, begin, end) {
	    return Random.pick(this.engine, array, begin, end);
	  };
	
	  function returnUndefined() {
	    return void 0;
	  }
	  var slice = Array.prototype.slice;
	  Random.picker = function (array, begin, end) {
	    var clone = slice.call(array, begin, end);
	    if (!clone.length) {
	      return returnUndefined;
	    }
	    var distribution = Random.integer(0, clone.length - 1);
	    return function (engine) {
	      return clone[distribution(engine)];
	    };
	  };
	
	  Random.shuffle = function (engine, array, downTo) {
	    var length = array.length;
	    if (length) {
	      if (downTo == null) {
	        downTo = 0;
	      }
	      for (var i = (length - 1) >>> 0; i > downTo; --i) {
	        var distribution = Random.integer(0, i);
	        var j = distribution(engine);
	        if (i !== j) {
	          var tmp = array[i];
	          array[i] = array[j];
	          array[j] = tmp;
	        }
	      }
	    }
	    return array;
	  };
	  proto.shuffle = function (array) {
	    return Random.shuffle(this.engine, array);
	  };
	
	  Random.sample = function (engine, population, sampleSize) {
	    if (sampleSize < 0 || sampleSize > population.length || !isFinite(sampleSize)) {
	      throw new RangeError("Expected sampleSize to be within 0 and the length of the population");
	    }
	
	    if (sampleSize === 0) {
	      return [];
	    }
	
	    var clone = slice.call(population);
	    var length = clone.length;
	    if (length === sampleSize) {
	      return Random.shuffle(engine, clone, 0);
	    }
	    var tailLength = length - sampleSize;
	    return Random.shuffle(engine, clone, tailLength - 1).slice(tailLength);
	  };
	  proto.sample = function (population, sampleSize) {
	    return Random.sample(this.engine, population, sampleSize);
	  };
	
	  Random.die = function (sideCount) {
	    return Random.integer(1, sideCount);
	  };
	  proto.die = function (sideCount) {
	    return Random.die(sideCount)(this.engine);
	  };
	
	  Random.dice = function (sideCount, dieCount) {
	    var distribution = Random.die(sideCount);
	    return function (engine) {
	      var result = [];
	      result.length = dieCount;
	      for (var i = 0; i < dieCount; ++i) {
	        result[i] = distribution(engine);
	      }
	      return result;
	    };
	  };
	  proto.dice = function (sideCount, dieCount) {
	    return Random.dice(sideCount, dieCount)(this.engine);
	  };
	
	  // http://en.wikipedia.org/wiki/Universally_unique_identifier
	  Random.uuid4 = (function () {
	    function zeroPad(string, zeroCount) {
	      return stringRepeat("0", zeroCount - string.length) + string;
	    }
	
	    return function (engine) {
	      var a = engine() >>> 0;
	      var b = engine() | 0;
	      var c = engine() | 0;
	      var d = engine() >>> 0;
	
	      return (
	        zeroPad(a.toString(16), 8) +
	        "-" +
	        zeroPad((b & 0xffff).toString(16), 4) +
	        "-" +
	        zeroPad((((b >> 4) & 0x0fff) | 0x4000).toString(16), 4) +
	        "-" +
	        zeroPad(((c & 0x3fff) | 0x8000).toString(16), 4) +
	        "-" +
	        zeroPad(((c >> 4) & 0xffff).toString(16), 4) +
	        zeroPad(d.toString(16), 8));
	    };
	  }());
	  proto.uuid4 = function () {
	    return Random.uuid4(this.engine);
	  };
	
	  Random.string = (function () {
	    // has 2**x chars, for faster uniform distribution
	    var DEFAULT_STRING_POOL = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-";
	
	    return function (pool) {
	      if (pool == null) {
	        pool = DEFAULT_STRING_POOL;
	      }
	
	      var length = pool.length;
	      if (!length) {
	        throw new Error("Expected pool not to be an empty string");
	      }
	
	      var distribution = Random.integer(0, length - 1);
	      return function (engine, length) {
	        var result = "";
	        for (var i = 0; i < length; ++i) {
	          var j = distribution(engine);
	          result += pool.charAt(j);
	        }
	        return result;
	      };
	    };
	  }());
	  proto.string = function (length, pool) {
	    return Random.string(pool)(this.engine, length);
	  };
	
	  Random.hex = (function () {
	    var LOWER_HEX_POOL = "0123456789abcdef";
	    var lowerHex = Random.string(LOWER_HEX_POOL);
	    var upperHex = Random.string(LOWER_HEX_POOL.toUpperCase());
	
	    return function (upper) {
	      if (upper) {
	        return upperHex;
	      } else {
	        return lowerHex;
	      }
	    };
	  }());
	  proto.hex = function (length, upper) {
	    return Random.hex(upper)(this.engine, length);
	  };
	
	  Random.date = function (start, end) {
	    if (!(start instanceof Date)) {
	      throw new TypeError("Expected start to be a Date, got " + typeof start);
	    } else if (!(end instanceof Date)) {
	      throw new TypeError("Expected end to be a Date, got " + typeof end);
	    }
	    var distribution = Random.integer(start.getTime(), end.getTime());
	    return function (engine) {
	      return new Date(distribution(engine));
	    };
	  };
	  proto.date = function (start, end) {
	    return Random.date(start, end)(this.engine);
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Random;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && typeof require === "function") {
	    module.exports = Random;
	  } else {
	    (function () {
	      var oldGlobal = root[GLOBAL_KEY];
	      Random.noConflict = function () {
	        root[GLOBAL_KEY] = oldGlobal;
	        return this;
	      };
	    }());
	    root[GLOBAL_KEY] = Random;
	  }
	}(this));

/***/ },
/* 17 */
/***/ function(module, exports) {

	/*!
	* screenfull
	* v3.3.1 - 2017-07-07
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/5\.1[.\d]* Safari/.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(13);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(18)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?-url!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/index.js!../../node_modules/postcss-loader/index.js!./index.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?-url!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/index.js!../../node_modules/postcss-loader/index.js!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = {
	  WEB_SOCKET_APP_PORT: 3200,
	
	  ITEM_FEN: { weight: 990, name: 'fen' },
	  ITEM_TUFLYA: { weight: 960, name: 'tuf' },
	  ITEM_VANTUZ: { weight: 890, name: 'van' },
	  ITEM_YAD: { weight: 850, name: 'yad' },
	  ITEM_BANAN: { weight: 760, name: 'ban' },
	
	  ITEM_WEIGHT_DELTA: 20,
	};


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** build/bundle.js
 **/